module.exports = __webpack_public_path__ + "static/media/artist_03.d76d0910.png";